<template>
  <div class="subject-detail">
    <div class="pc">
      <div class="banner ban_title lecturer" v-for="(producer, index) in subject.producers" :key="'subject_producers_'+index">
        <div class="con">
          <div class="con_person row">
            <div class="le col-lg-3 col-md-3 col-sm-3">
              <div class="tupian_con">
                <div class="tupian row">
                  <div class="img_per">
                    <img src="../assets/img/per_back.png" class="per">
                    <img :src="global.getSrc(JSON.parse(producer.thumbs)[0].fileUrl,1)" v-if="producer.thumbs&&producer.thumbs!=''" class="img-circle">
                  </div>
                </div>
              </div>
            </div>
            <div class="ri col-lg-9 col-md-9 col-sm-9">
              <div class="row">
                <h3>专题出品人： {{producer.name || '敬请期待'}}</h3>
              </div>
              <div class="row">
                <h5>{{producer.company}} {{producer.department||producer.office||''}} {{producer.position}}</h5>
              </div>
              <div class="row">
                <p>{{producer.ldesc}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="banner ban_title mob">
      <slot v-for="(producer, index) in subject.producers">
        <div class="con" :class="subject?'':'blank'" :key="'subject_producers_c_'+index">
          <div class="row">
            <div class="tupian_con">
              <div class="tupian row">
                <div class="img_per">
                  <img src="../assets/img/per_back.png" class="per">
                  <img :src="producer.thumbs?global.getSrc(JSON.parse(producer.thumbs)[0].fileUrl,1):''" class="img-circle">
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <h3>专题出品人： {{subject&&producer.name||'敬请期待'}}</h3>
            <h5>{{producer.company||''}}  {{producer.position||''}}</h5>
          </div>
        </div>
        <div class="row" :key="'subject_producers_d_'+index">
          <p>{{producer.ldesc}}</p>
        </div>
      </slot>
    </div>
    <div class="pc_content subject">
      <div class="con">
        <div class="le">
          <img src="../assets/img/zhuanti.png">
        </div>
        <div class="ri">
          <h1>专题：{{subject.venueName}}</h1>
          <p class="subject-time" v-html="subjectTime"></p>
          <p v-html="subject.description"></p>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="pc_content subject bgcolor-con">
      <div class="con">
        <div class="le">
          <img src="../assets/img/teacher.png">
        </div>
        <div class="ri">
          <h1>本专题下的议题</h1>
          <slot v-if="difference && difference.courses && Object.keys(difference.courses) && Object.keys(difference.courses).length > 0">
            <slot v-for="(course,cindex) in difference.courses">
              <router-link v-if="course.id" :to="formatHref('/course', {cid: course.id, dif:1, vid:subject.id, source:global.area_id=='4488'?encodeURIComponent('腾讯云'):''})" :key="'c_a_r_'+cindex">
                <div class="teacher_jieshao teshu">
                  <h5>{{course.title}}</h5>
                  <h6 v-for="(lec,lindex) in course.lecturer" :key="'c_a_l_'+cindex+lindex"
                  ><span>{{lec.penName || lec.name}}</span> {{lec.company}} {{lec.position}} </h6>
                  <h6>所属专题：{{subject.venueName}}</h6>
                  <!-- <h4 class="pc">课程概要</h4> -->
                  <h4 class="pc">分享概要</h4>
                  <p class="pc" v-html="course.desc"></p>
                  <h4 class="pc">听众收益</h4>
                  <p class="pc" v-html="course.profit"></p>
                </div>
              </router-link>
              <a v-else :key="'c_a_'+cindex">
                <div class="teacher_jieshao teshu">
                  <h5>{{course.courseTitle}}</h5>
                  <h6 v-if="course.lecturers && course.lecturers[0]"
                  ><span>{{course.lecturers[0].name}}</span> {{course.lecturers[0].company}} {{course.lecturers[0].position}} </h6>
                  <h6>所属专题：{{subject.venueName}}</h6>
                </div>
              </a>
              <div class="hex pc" v-if="Object.keys(difference.courses).length>1&&cindex<Object.keys(difference.courses).length-1" :key="'hex_'+cindex"></div>
            </slot>
          </slot>
          <slot v-else>
            <slot v-for="(item,index) in subject.courses">
              <router-link :to="formatHref('/course', {cid: item.courseid})">
                <div class="teacher_jieshao teshu">
                  <h5>{{item.courseTitle}}</h5>
                  <h6><span>{{item.name}}</span> {{item.company}} {{item.position}} </h6>
                  <h6>所属专题：{{subject.venueName}}</h6>
                  <!-- <h4 class="pc">课程概要</h4> -->
                  <h4 class="pc">分享概要</h4>
                  <p class="pc" v-html="item.desc"></p>
                  <h4 class="pc">听众收益</h4>
                  <p class="pc" v-html="item.profit"></p>
                </div>
              </router-link>
              <div class="hex pc" :v-if="subject.courses.length>1&&index<subject.courses.length-1" :key="'hex_'+index"></div>
            </slot>
          </slot>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <!-- {{ relate }} -->
    <div class="pc_content relate">
      <div class="con">
        <h1 class="h1">其他相关专题</h1>
        <ul class="caselist">
          <slot v-for="(item,index) in relate">
            <li v-if="item && !item.venueName.includes('开幕式')" :key="'subject_venues_'+index"
            class="col-lg-4 col-md-4 col-sm-4" :class="index<9?('anli_0'+(index+1)):('anli_'+(index+1))">
              <router-link :to="formatHref('/subject-detail', {vid: item.id})">
                <div class="wenzi">
                  <h2>{{item.venueName}}</h2>
                  <div class="nali_img"></div>
                  <h3>专题出品人：{{item.producers.name || '敬请期待'}}</h3>
                  <p>{{item.producers.company}}<br>{{item.producers.position}}</p>
                </div>
              </router-link>
            </li>
          </slot>
        </ul>
        <div class="bottom">
          <img src="../assets/img/foot_top.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixinSession } from '../mixin'

export default {
  name: 'SubjectDetail',
  mixins: [mixinSession],
  data () {
    return {
      param: '',
      subject_id: '',
      subject: '',
      relate: [],
      difference: {},
      metaInfo: {
        seoTitle: '',
        seoKeyword: '',
        seoDescription: ''
      }
    }
  },
  computed: {
    subjectTime () {
      const { date, times } = this.subject
      let startTime = times ? times.split('-')[0] : ''
      let endTime = times ? times.split('-').pop() : ''
      startTime = startTime.length<5?'0'+startTime:startTime
      endTime = endTime.length<5?'0'+endTime:endTime

      let time = date ? this.global.formatTime(date, 'Y.M.D', 2, 2) : ''
      if (time === '2026.05.30' && startTime >= '12:00') {
        time += '&emsp;13:30-16:30'
      } else {
        time += startTime ? `&emsp;${startTime}` : ''
        time += endTime ? `-${endTime}` : ''
      }
      return time
    },
  },
  metaInfo () {
    // 这里的this可以访问到asyncData返回的数据
    const { metaInfo, subject } = this
    const producers = (subject.producers || []).map(item => item.name).join(', ')
    const seoTitle = (metaInfo && metaInfo.seoTitle) || `专题详情${subject.venueName ? ' - ' + subject.venueName : ''}${producers ? ' | 出品人 - ' + producers : ''}`
    const seoDescription = (metaInfo && metaInfo.seoDescription) || (subject.desc || '').slice(0, 150)
    const seoKeyword = (metaInfo && metaInfo.seoKeyword) || subject.description || ''
    return {
      title: seoTitle,
      meta: [
        { name: 'description', content: seoDescription },
        { name: 'keywords', content: seoKeyword }
      ]
    }
  },
  created () {
    this.param = this.$route.query
    this.subject_id = this.param.vid || this.param.id
    this.getDetail()
  },
  watch: {
    '$route' (to, from) { // 监听路由是否变化
      if (to && to.query) {
        let tId = (to.query.vid || to.query.id || '').toString().trim()
        let fId = (from && from.query && (from.query.vid || from.query.id)) || null
        fId = fId && fId.toString().trim()
        if (tId && tId !== fId) {
          this.param = to.query
          this.subject_id = tId
          this.getDetail()
        }
      }
    }
  },
  methods: {
    getDetail () {
      let surl = this.global.urlNew.subject_detail + this.subject_id
      this.$http.jsonp(surl)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          if ([0, '0'].includes(data.errno) && data.data && data.data.id) {
            // console.log('SubjectDetail ', data.data)
            this.subject = { ...data.data, day: this.global.formatTime(data.data.date, 'Y-M-D') }
            if (data.data.seo !== null && !Array.isArray(data.data.seo)) {
              this.metaInfo = data.data.seo
            }
            // if (!(this.metaInfo && this.metaInfo.seoTitle)) {
            //   this.metaInfo.seoTitle = data.data.title + ' -  ' + this.global.config[this.area_id].title || ''
            // }
            this.getDifference()
            this.getRelate()
          }
        })
    },
    getRelate () {
      // console.log('SubjectDetail venues ', this.subject.venues)
      let relate = []
      for (let i = 0; i < this.subject.venues.length; i++) {
        if (this.subject.venues[i].venueName.includes('开幕式')) {
          relate[i] = ''
        } else {
          // let producers = this.subject.venues[i].producers
          //   ? {name: this.subject.venues[i].producers, company: '', position: ''}
          //   : {name: '', company: '', position: ''}
          let producers = {name: '', company: '', position: ''}
          relate.push({
            id: this.subject.venues[i].id,
            venueName: this.subject.venues[i].venueName,
            producers
          })
          if (this.subject.venues[i].producerId && this.subject.venues[i].producerId.toString().trim() !== '') {
            this.subject.venues[i].producerId.split(',').forEach((producerId, pIndex) => {
              let purl = `${this.global.urlNew.lecturer}${this.global.area_id}/${producerId}`
              this.$http.jsonp(purl)
                .then((res) => {
                  return res.json()
                })
                .then((res) => {
                  if ([0, '0'].includes(res.errno)) {
                    // console.log('SubjectDetail producers ', i, this.subject.venues[i].producers, res.data)
                    relate[i].producers.name += (pIndex>0?' / ':'') + (res.data.penName || res.data.name)
                    relate[i].producers.company += (pIndex>0?' / ':'') + res.data.company
                    relate[i].producers.position += (pIndex>0?' / ':'') + res.data.position
                  }
                  // console.log('SubjectDetail relate - ', relate)
                  this.relate = relate
                })
            })
          } else if (this.subject.venues[i].id) {
            let purl = this.global.urlNew.subject_detail + this.subject.venues[i].id
            this.$http.jsonp(purl)
              .then((data) => {
                return data.json()
              })
              .then((data) => {
                if ([0, '0'].includes(data.errno) && data.data && data.data.id) {
                  console.log('SubjectDetail venues ', data.data)
                  let producers = { name: '', company: '', position: '' }
                  data.data.producers.map(item => {
                    producers.name += (item.penName || item.name) ? (item.penName || item.name) + ' / ' : ''
                    producers.company += item.company ? item.company + ' / ' : ''
                    producers.position += item.position ? item.position + ' / ' : ''
                  })
                  producers.name = producers.name.slice(0, -1)
                  producers.company = producers.company.slice(0, -1)
                  producers.position = producers.position.slice(0, -1)
                  relate[i].producers = producers
                }
                // console.log('SubjectDetail relate -- ', relate)
                this.relate = relate
              })
          }
        }
      }
    },
    getDifference () {
      if (this.global.config[this.global.area_id]['difference'] && parseInt(this.global.config[this.global.area_id]['difference'])) {
        let url = this.global.urlNew.sue['type'] + this.global.config[this.global.area_id]['difference']
        this.$http
          .jsonp(url)
          .then((data) => {
            return data.json()
          })
          .then((res) => {
            // console.log('difference ', res)
            if ([0, '0'].includes(res.errno) && res.data) {
              let type = ''
              let typeList = []
              for (let item of res.data) {
                type = item.typeName && typeof item.typeName === 'string' && item.typeName.toLocaleLowerCase()
                if (type && type.includes('mpd') && type.includes(this.global.config[this.global.area_id].year)) {
                  typeList.push({ id: item.id, name: type.split('#')[1], clauseActivityId: type.split('#')[2] || '' })
                }
              }
              this.getScheduleDifference(typeList)
            }
          })
      }
    },
    getScheduleDifference (typeList) {
      // {'2024sz_1_6_pm':{ length:6, courses:[], linkUrl:'https://www.msup.com.cn/site/clause-activity?id=3784' }}
      if (typeList.length > 0) {
        // 初始化数据结构
        let difference = {}
        for (let type of typeList) {
          difference[type.name] = { length: 0, courses: [], linkUrl: '' }
          if (type.clauseActivityId) {
            difference[type.name].linkUrl = `https://www.msup.com.cn/site/clause-activity?id=${type.clauseActivityId}`
          }
          if (type.name.includes('am')) {
            difference[type.name].length = 3
          } else if (type.name.includes('pm')) {
            difference[type.name].length = 4
          }
          this.$forceUpdate()
        }
        // 获取数据
        let url = this.global.urlNew.sue['arr'] + this.global.config[this.global.area_id]['difference']
        this.$http
          .jsonp(url)
          .then((data) => {
            return data.json()
          })
          .then((res) => {
            if ([0, '0'].includes(res.errno) && res.data && res.data[0] && res.data[0].length > 0) {
              // console.log('difference ', res.data[0])
              for (let typeItem of typeList) {
                if (difference[typeItem.name]) {
                  difference[typeItem.name].courses = []
                  difference[typeItem.name].timeStamp = new Date().getTime()
                  // let course = {}
                  let lecturers = []
                  let lecturer = ''
                  let times = []
                  // let titles = []
                  // let title = ''
                  for (let index in res.data[0]) {
                    let course = res.data[0][index]
                    // if (course.detailType.toString().trim() === '281') {
                    if (course.detailType.toString().trim() === typeItem.id.toString().trim()) {
                      lecturers = course.content && course.content.length > 0 && course.content.split(' /// ')
                      if (course.content_note && course.content_note.length > 0) {
                        times = (course.content_note.split('scheduleTitle--')[0] || '').replace('time--', '').replace(/\r\n/g, '').split('-')
                        // titles = (course.content_note.split('scheduleTitle--')[1] || '').replace(/^\r\n/, '').split('\r\n')
                      }
                      difference[typeItem.name].courses.push({
                        courseId: (course.title && course.title.split('||') && course.title.split('||')[1]) || '',
                        courseTitle: (course.title && course.title.split('||') && course.title.split('||')[0]) || '敬请期待',
                        lecturers: [],
                        times: times
                      })
                      let cIndex = difference[typeItem.name].courses.length - 1
                      for (let lindex in lecturers) {
                        lecturer = lecturers[lindex] || ''
                        // title = titles[lindex] || '';
                        if (lecturer.split(' || ')[0] && lecturer.split(' || ')[0].trim() !== '客户技术高层') {
                          difference[typeItem.name].courses[cIndex].lecturers.push({
                            name: lecturer.split(' || ')[0] || '',
                            company: lecturer.split(' || ')[1] || '',
                            position: lecturer.split(' || ')[2] || ''
                            // courseTitle: title, // 不需要显示讲师议题
                          })
                        }
                      }
                    }
                  }
                  difference[typeItem.name].length = difference[typeItem.name].courses.length || difference[typeItem.name].length
                  // this.scheduleDifference = difference
                }
              }
              let dKeys = Object.keys(difference)
              let dFlag = false
              for (let k of dKeys) {
                if (k && k.includes(this.global.config[this.global.area_id].year)) {
                  dFlag = true
                  break
                }
              }
              if (dFlag) {
                this.formatScheduleDifference(difference)
              }
            }
          })
      }
    },
    formatScheduleDifference (difference) {
      let purl = this.global.urlNew.place + this.global.area_id
      this.$http
        .jsonp(purl)
        .then((res) => {
          return res.json()
        })
        .then((res) => {
          if ([200, '200'].includes(res.status) && res.data) {
            let days = [ this.global.formatTime(res.data.startTime, 'Y-M-D'), this.global.formatTime(res.data.endTime, 'Y-M-D') ]
            let y = this.global.config[this.global.area_id].year
            let d = days.indexOf(this.subject.day) + 1
            let g = this.subject.groupId
            let p = (this.subject.times && this.subject.times.slice(0, 2)) ? ((this.subject.times.slice(0, 2) > '12' && this.subject.times.slice(0, 2) < '20') ? 'pm' : 'am') : ''
            let dKey = `${y}_${d}_${g}_${p}`
            // console.log('difference-- ', dKey, difference)
            if (difference[dKey] && difference[dKey].courses && difference[dKey].courses.length > 0) {
              this.difference = { courses: {} }
              for (let index in difference[dKey].courses) {
                let item = difference[dKey].courses[index]
                this.difference.courses[index] = item
                if (item.courseId) {
                  this.getCourse(index, item.courseId)
                }
              }
            }
          }
        })
    },
    getCourse (index, cid) {
      let curl = `${this.global.urlNew.course['course']}${this.global.area_id}/${cid}`
      this.$http
        .jsonp(curl)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          if ([0, '0'].includes(data.errno) && data.data && data.data.id) {
            // console.log('course ', cid, data.data)
            this.difference.courses[index] = data.data
            this.$forceUpdate()
          }
        })
    }
  }
}
</script>

<style lang="scss">
// .year_before .subject-detail .banner.ban_title.mob {
//   background-image: url(../assets/img/2021/richeng/teacher_wap.png);
// }
// .year_after .subject-detail .banner.ban_title.mob {
//   background-image: url(../assets/img/2024/teacher_wap.png);
// }

#app .subject-detail {
  .pc .banner.ban_title {
    height: auto;
    min-height: 300px;
    .con {
      width: 100%;
      max-width: 1020px;
      margin: 0 auto;
      padding-top: 20px;
      .con_person {
        padding-bottom: 40px;
        .le {
          width: 25%;
          padding: 0;
          float: left;
          .tupian_con {
            width: 80%;
            margin: 0 auto;
            margin-top: 30px;
            .tupian {
              // border: 7px solid var(--main-bgcolor);
              border-radius: 50%;
              margin-left: 0;
              margin-right: 0;
              .img_per {
                width: 100%;
                margin: 0 auto;
                background-size: 100%;
                position: relative;
                // background-image: url(../assets/img/2021/per_back.png);
                // background-size: 100% 100%;
                img {
                  border: 5px solid #ffffff;
                  &.per {
                    width: 100%;
                    // margin-left: -100%;
                    //  position: absolute;
                    position: relative;
                    z-index: 5;
                    border: none;
                  }
                  &:not(.per) {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    object-position: top;
                    position: absolute;
                    z-index: 4;
                    left: 0;
                    top: 0;
                  }
                }
              }
            }
          }
        }
        .ri {
          width: 75%;
          margin-top: 30px;
          float: left;
          .row {
            margin-left: 0;
            margin-right: 0;
            * {
              color: #ffffff;
              text-align: left;
            }
            h3 {
              height: 40px;
              line-height: 40px;
              font-size: 30px;
            }
            h5 {
              font-size: 16px;
              margin-top: 15px;
              margin-bottom: 17px;
            }
            p {
              line-height: 30px;
              font-size: 16px;
              color: #dbdfe2;
              &.subject-time {
                // 
              }
            }
          }
        }
      }
    }
  }
  .banner.ban_title.mob {
    height: auto;
    background-position: top;
    background-size: cover;
    .con {
      // height: 210px;
      height: fit-content;
      &.blank {
        height: 210px;
      }
      .row {
        width: 100%;
        .tupian_con {
          width: 28%;
          min-width: 105px;
          max-width: 200px;
          margin: 0 auto;
          margin-top: 15px;
          .tupian {
            // border: 7px solid var(--main-bgcolor);
            border-radius: 50%;
            margin-left: 0;
            margin-right: 0;
            .img_per {
              width: 100%;
              margin: 0 auto;
              background-size: 100%;
              position: relative;
              img {
                border: 3px solid transparent;
                &.per {
                  width: 100%;
                  // margin-left: -100%;
                  // position: absolute;
                  position: relative;
                  border: none;
                }
                &:not(.per) {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  object-position: top;
                  position: absolute;
                  top: 0;
                  left: 0;
                }
              }
            }
          }
        }
        h3 {
          // color: #000000;
          color: #ffffff;
          // font-size: 17px;
          font-size: 18px;
          text-align: center;
          margin-top: 10px;
        }
        h5 {
          // color: #999999;
          color: #cccccc;
          // font-size: 14px;
          font-size: 15px;
          font-weight: 400;
          text-align: center;
          margin-top: 5px;
          padding: 0;
        }
      }
    }
    .row {
      width: 100%;
      padding: 0 5%;
      margin: 0;
      &:not(:nth-of-type(1)) {
        padding-bottom: 10px;
      }
      p {
        // color: #666666;
        color: #dbdfe2;
        // font-size: 12px;
        font-size: 13px;
        line-height: 22px;
        padding-left: 5px;
        padding-right: 5px;
        text-align: left;
        letter-spacing: 1px;
      }
    }
  }
  .pc_content.subject {
    .con {
      width: 100%;
      max-width: 1020px;
      margin: 0 auto;
      padding: 80px 0 90px 0;
      .le {
        width: 10%;
        float: left;
        padding-left: 15px;
      }
      .ri {
        width: 89%;
        float: left;
        padding-left: 1%;
        padding-right: 1%;
        h1 {
          font-size: 30px;
          color: #000000;
          padding-top: 10px;
          margin-bottom: 0;
        }
        p {
          font-size: 15px;
          line-height: 30px;
          color: #666666;
          padding-top: 30px;
          &.subject-time {
            padding-top: 10px;
          }
        }
        a {
          .teacher_jieshao {
            border-left: 4px solid var(--main-bgcolor);
            padding-left: 10px;
          }
          .teshu {
            margin-top: 40px;
            margin-bottom: 40px;
            h5 {
              color: #1378d9;
              font-size: 24px;
            }
            h6 {
              color: #808080;
              font-size: 14px;
              margin-top: 8px;
              span {
                color: #1378d9;
              }
            }
            h4 {
              color: #333333;
              font-size: 20px;
              margin-top: 30px;
            }
            p {
              padding-top: 5px;
              white-space: pre-wrap;
            }
          }
        }
      }
    }
  }
  .pc_content.relate {
    h1 {
      padding: 60px 0 40px 0;
    }
    .bottom {
      width: 100%;
      text-align: center;
      img {
        width: 100%;
        max-width: 858px;
      }
    }
  }
  @media (max-width:767px) {
    // .banner.ban_title.mob,
    .pc_content.subject {
    background-color: #f9f9f9;
    }
    .pc_content.subject {
    padding: 0;
    &.bgcolor-con {
      padding-bottom: 30px;
    }
    .con {
      width: 90%;
      margin: 0 auto;
      padding: 40px 0 0 0;
      .le {
      width: 0;
      padding-left: 0;
      img {
        width: 45px;
        padding-left: 5px;
      }
      }
      .ri {
        width: 100%;
        padding-left: 0;
        padding-right: 0;
        h1 {
          min-height: 37px;
          line-height: 37px;
          font-size: 24px;
          padding-top: 0;
          margin-left: 50px;
        }
        p {
          padding-top: 5px;
          font-size: 12px;
          &.subject-time {
            padding-top: 0;
            padding-left: 50px;
          }
        }
        a {
          .teshu {
            border-width: 2px;
            padding: 1px 0;
            padding-left: 8px;
            margin-top: 20px;
            margin-bottom: 20px;
            h5 {
              font-size: 17px;
              padding-bottom: 5px;
            }
            h6 {
              font-size: 12px;
            }
          }
        }
      }
    }
    }
    .pc_content.relate {
    padding: 0;
    h1 {
      padding: 25px 0;
    }
    ul.caselist {
      width: 90%;
      padding: 0 15px;
      margin: 0 auto;
      li {
      a {
        .wenzi {
        h2 {
          height: 80px;
          line-height: 20px;
        }
        }
      }
      }
    }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/viewsNew/SubjectDetail.vue